/**
 * Created by razial on 19.12.2025.
 */

const BackwardCompatibility = function () {
    this.keys = new Map();

    for (const factory of BackwardCompatibility.REGISTRATIONS) {
        const compatability = factory();

        if (!compatability.keys || !compatability.keys.length) {
            throw new Error("compatability has no keys");
        }

        for (const key of compatability.keys) {
            if (this.keys.has(key)) {
                throw new Error(`duplicate compatability keys '${key}'`);
            }

            this.keys.set(key, compatability);
        }
    }
};

BackwardCompatibility.prototype.has = function (key) {
    return this.keys.has(key);
};

BackwardCompatibility.prototype.save = function (key, fromSever) {
    const compatability = this.keys.get(key);
    if (compatability) {
        compatability.onSave(fromSever);
    }
};

BackwardCompatibility.prototype.getInfo = function (key) {
    const compatability = this.keys.get(key);
    if (compatability) {
        return compatability.onSync();
    }
};

BackwardCompatibility.REGISTRATIONS = new Set();
